import { render, staticRenderFns } from "./arrangeCandidate.vue?vue&type=template&id=42fb9faa&scoped=true"
import script from "./arrangeCandidate.vue?vue&type=script&lang=js"
export * from "./arrangeCandidate.vue?vue&type=script&lang=js"
import style0 from "./arrangeCandidate.vue?vue&type=style&index=0&id=42fb9faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fb9faa",
  null
  
)

export default component.exports